import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import type { RoleCode } from "@/shared/api/types";
import { useAuth } from "@/shared/hooks/useAuth";

interface Props {
  roles?: RoleCode[];
  children: ReactNode;
}

export const RouteGuard = ({ roles, children }: Props) => {
  const { isAuthenticated, hasAnyRole } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (roles && roles.length > 0 && !hasAnyRole(roles)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
